import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\User\DeleteUserAvatarController::__invoke
* @see app/Http/Controllers/User/DeleteUserAvatarController.php
* @route '/api/user/{user}/avatar'
*/
const DeleteUserAvatarController = (args: { user: string | { id: string } } | [user: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: DeleteUserAvatarController.url(args, options),
    method: 'delete',
})

DeleteUserAvatarController.definition = {
    methods: ["delete"],
    url: '/api/user/{user}/avatar',
} satisfies RouteDefinition<["delete"]>

/**
* @see \App\Http\Controllers\User\DeleteUserAvatarController::__invoke
* @see app/Http/Controllers/User/DeleteUserAvatarController.php
* @route '/api/user/{user}/avatar'
*/
DeleteUserAvatarController.url = (args: { user: string | { id: string } } | [user: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { user: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { user: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            user: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        user: typeof args.user === 'object'
        ? args.user.id
        : args.user,
    }

    return DeleteUserAvatarController.definition.url
            .replace('{user}', parsedArgs.user.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\User\DeleteUserAvatarController::__invoke
* @see app/Http/Controllers/User/DeleteUserAvatarController.php
* @route '/api/user/{user}/avatar'
*/
DeleteUserAvatarController.delete = (args: { user: string | { id: string } } | [user: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: DeleteUserAvatarController.url(args, options),
    method: 'delete',
})

export default DeleteUserAvatarController